import Utils from "../utils/utils";

const logAmplitute = async ({ eventType, guestSession, eventProperties }) => {
    let eventId = JSON.parse(window.sessionStorage.getItem("amplitude.eventId") || "0");
    eventId = eventId + 1;
    window.sessionStorage.setItem("amplitude.eventId", eventId);

    let sessionId = JSON.parse(window.sessionStorage.getItem("amplitude.sessionId") || "null");
    if (!sessionId) {
        sessionId = Date.now();
        window.sessionStorage.setItem("amplitude.sessionId", sessionId);
    }

    // If this fails we just want to carry on
    fetch(process.env.REACT_APP_AMPLITUDE_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Accept': '*/*',
        },
        body: JSON.stringify({
            api_key: process.env.REACT_APP_AMPLITUDE_API_KEY,
            events: [{
                user_id: guestSession,
                event_type: eventType,
                session_id: sessionId,
                event_id: eventId,
                insert_id: Utils.generateId(),
                os_name: window.navigator.userAgent,
                device_type: window.navigator.userAgentData ? window.navigator.userAgentData.platform : window.navigator.userAgent,
                event_properties: eventProperties
            }]
        }),
    });
}

const Amplitude = {
    logAmplitute
}

export default Amplitude;